<template>

<div class="pedidos py-3">
    <header class="mb-4">
        <div  class="div-cart">
            <h1><i class="fa fa-clipboard"> </i> Meus Pedidos</h1>
        </div>
    </header>

    <div class="card text-center">
      <div class="card-header">
          <ul class="nav nav-pills">
              <li class="nav-item">
                  <a href="#p-abertos" class="nav-link active show" data-toggle="tab" >Pedidos em Aberto</a>
              </li>
              <li class="nav-item">
                  <a href="#p-fechados" class="nav-link" data-toggle="tab" >Pedidos anteriores</a>
              </li>
          </ul>
      </div>
      <div class="card-body">
          <div class="tab-content pedidos">
              <div class="tab-pane" id="activity">
                  <h3 class="text-center">Display User Activity</h3>
              </div>

              <!-- LISTA DOS PEDIDOS EM ABERTO -->
              <div id="p-abertos" class="tab-pane active show" >

                <div v-if="!carregando" >

                  <div
                    v-for="pedido in pedidos.filter(pedido => pedido.status_id == 1 || pedido.status_id == 2 || pedido.status_id == 3 )"
                    :key="pedido.id"
                  >
                    <a href="#" @click="modalPedido(pedido)">
                      <div class="card my-3">
                        <div class="card-body">

                          <div class="row">
                            <div class="col align-middle m-auto">
                              <h4 class="card-title m-0">Pedido {{pedido.numero}}</h4>
                              <span v-if="inquilino.tempo">Tempo extimado de entrega: {{inquilino.tempo}}</span>
                            </div>
                            <div class="col">
                              <div class="alert mb-0" role="alert"
                                :class="{ 'alert-secondary': pedido.status_id==1, 'alert-warning': pedido.status_id==2 , 'alert-info': pedido.status_id==3 }"
                              >
                                <i class="mr-1 fa-lg"
                                  :class="{ 'far fa-clipboard': pedido.status_id==1,
                                            'fas fa-hamburger': pedido.status_id==2,
                                            'fas fa-motorcycle': pedido.status_id==3&&pedido.entrega!='Retirar no Balcão',
                                            'fas fa-box': pedido.status_id==3&&pedido.entrega=='Retirar no Balcão' }"
                                ></i> Status: {{pedido.status_id==3&&pedido.entrega=="Retirar no Balcão"?"Aguardando retirada":pedido.status}}
                              </div>
                            </div>
                          </div>

                        </div>
                      </div>
                    </a>

                  </div>
                </div>
                <div v-else class="text-center">
                    <div class="spinner-border text-info my-5" role="status">
                        <span class="sr-only">Loading...</span>
                    </div>
                </div>

              </div>

              <!-- LISTA DOS PEDIDOS FECHADOS -->
              <div id="p-fechados" class="tab-pane">


                <div
                  v-for="pedido in pedidos.filter(pedido => pedido.status_id == 4 || pedido.status_id == 5 )"
                  :key="pedido.id"
                >
                  <a href="#" @click="modalPedido(pedido)">
                    <div class="card my-3">
                      <div class="card-body">

                        <div class="row">
                          <div class="col align-middle m-auto">
                            <h4 class="card-title m-0">Pedido {{pedido.numero}}</h4>
                          </div>
                          <div class="col">
                            <div class="alert mb-0" role="alert"
                              :class="{ 'alert-success': pedido.status_id==4, 'alert-danger': pedido.status_id==5 }"
                            >
                              <i class="mr-1 fa-lg"
                                :class="{ 'fas fa-clipboard-check': pedido.status_id==4, 'fas fa-window-close': pedido.status_id==5 }"
                              ></i> Status: {{pedido.status}}
                            </div>
                          </div>
                        </div>

                      </div>
                    </div>
                  </a>

                </div>




              </div>

          </div>



      </div>
  </div>



  <!-- Modal -->

  <div class="modal fade" id="modalPedido" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Detalhes do Pedido</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">



        <div
            class="card card-success card-outline collapsed-card"
        >
            <div class="card-header">
                <div class="left">
                    <h5 class="">Pedido: <strong>{{pedidoAtivo.numero}}</strong></h5>

                </div>
                <div class="right">
                    <p>{{pedidoAtivo.data_criacao}}</p>
                </div>

            </div>
            <div class="card-body">
                <p><strong>Nome do Cliente:</strong>  {{pedidoAtivo.nome_do_cliente}}</p>
                <p><strong>Telefone:</strong> {{pedidoAtivo.telefone}}</p>
                <p><strong>E-mail: </strong>{{pedidoAtivo.email}}</p>
                <p v-if="pedidoAtivo.endereco"><strong>Endereço:</strong> {{pedidoAtivo.endereco.logradouro}}, {{pedidoAtivo.endereco.numero}}, {{pedidoAtivo.endereco.complemento}}, {{pedidoAtivo.endereco.bairro}} - CEP: {{pedidoAtivo.endereco.cep}}, {{pedidoAtivo.endereco.cidade}} ({{pedidoAtivo.endereco.referencia}}) </p>
                <p><strong>Entrega: </strong>{{pedidoAtivo.entrega}}</p>
                <hr>
                <h5>Itens:</h5>
                <div>

                    <table class="table">
                        <thead>
                            <tr>
                                <th width="30px">Qt</th>
                                <th>Produto</th>
                                <th width="50px">Valor</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="item in pedidoAtivo.itens" :key="item.id">
                                <td colspan="3" class="m-0 p-0" >
                                    <table class="table border-0 p-0">
                                        <tr>
                                            <th width="30px" class="pb-1">{{item.quantidade_descritiva}}</th>
                                            <th class="pb-1">{{item.nome}}</th>
                                            <th width="50px" class="pb-1 text-right">{{Intl.NumberFormat('pt-br', {style: 'currency', currency: 'BRL'}).format(item.valor_unitario*item.quantidade)}}</th>
                                        </tr>

                                        <!-- Sabores -->
                                        <tr v-if="item.sabores">
                                            <td class="border-0 p-0"></td>
                                            <td class="border-0 p-0">
                                                <span class="badge badge-success badge-pedido m-1"  v-for="sabor in item.sabores" :key="sabor.id"> {{sabor.nome}}</span>
                                            </td>
                                            <td class="border-0 p-0 text-right">

                                            </td>
                                        </tr>

                                        <!-- Massa -->
                                        <tr v-if="item.massa">
                                            <td class="border-0 p-0"></td>
                                            <td class="border-0 p-0">
                                                <span class="badge badge-success badge-pedido m-1" > <strong>Massa:</strong> {{item.massa.nome}} </span>
                                            </td>
                                            <td class="border-0 p-0 text-right">
                                                <span class="badge badge-success badge-pedido m-1" > +{{Intl.NumberFormat('pt-br', {style: 'currency', currency: 'BRL'}).format(item.massa.valor*item.quantidade)}}</span>

                                            </td>
                                        </tr>

                                        <!-- Borda -->
                                        <tr v-if="item.borda">
                                            <td class="border-0 p-0"></td>
                                            <td class="border-0 p-0">
                                                <span class="badge badge-success badge-pedido m-1" > <strong>Borda:</strong> {{item.borda.nome}} </span>
                                            </td>
                                            <td class="border-0 p-0 text-right">
                                                <span class="badge badge-success badge-pedido m-1" > +{{Intl.NumberFormat('pt-br', {style: 'currency', currency: 'BRL'}).format(item.borda.valor*item.quantidade)}} </span>

                                            </td>
                                        </tr>

                                        <!-- Subitem -->
                                        <tr v-if="item.subitens && item.subitens.length > 0">
                                            <td class="border-0 p-0"></td>
                                            <td class="border-0 p-0">
                                                <span v-for="subitem in item.subitens" :key="subitem.id" class="badge badge-success badge-pedido m-1">+{{subitem.nome}}</span>
                                            </td>
                                            <td class="border-0 p-0 text-right">
                                                <span class="badge badge-success badge-pedido m-1">+{{Intl.NumberFormat('pt-br', {style: 'currency', currency: 'BRL'}).format(item.valor_subitens*item.quantidade)}}</span>
                                            </td>
                                        </tr>

                                        <!-- Opcionais -->
                                        <tr v-if="item.opcionais && item.opcionais.length > 0">
                                            <td class="border-0 p-0"></td>
                                            <td class="border-0 p-0">
                                                <span v-for="opcional in item.opcionais" :key="opcional.id" class="badge badge-danger badge-pedido m-1">+{{opcional.nome}}</span>
                                            </td>
                                            <td class="border-0 p-0 text-right">
                                                <span class="badge badge-danger badge-pedido m-1">+{{Intl.NumberFormat('pt-br', {style: 'currency', currency: 'BRL'}).format(item.valor_opcionais*item.quantidade)}}</span>
                                            </td>
                                        </tr>

                                        <!-- Adicionais -->
                                        <tr v-if="item.adicionais && item.adicionais.length > 0">
                                            <td class="border-0 p-0"></td>
                                            <td class="border-0 p-0">
                                                <span v-for="adicional in item.adicionais" :key="adicional.id" class="badge badge-warning badge-pedido m-1">+{{adicional.nome}}</span>
                                            </td>
                                            <td class="border-0 p-0 text-right">
                                                <span class="badge badge-warning badge-pedido m-1" >+{{Intl.NumberFormat('pt-br', {style: 'currency', currency: 'BRL'}).format(item.valor_adicionais*item.quantidade)}}</span>
                                            </td>
                                        </tr>


                                        <!-- Clone -->
                                        <tr v-if="item.produtos && item.produtos.length > 0">
                                            <td class="border-0 p-0"></td>
                                            <td class="border-0 p-0">
                                                <div v-for="produto in item.produtos" :key="produto.id">
                                                    <!-- Clone - Sabor -->
                                                    <div class="alturadiv border-top">
                                                        <span class="badge badge-success badge-pedido m-1">+{{produto.nome}} ( <span v-for="sabor, index in produto.sabores" :key="index" >{{ sabor.nome }}{{ produto.sabores[index+1]?', ':'' }}</span> )</span>
                                                    </div>

                                                    <!-- Clone - Borda -->
                                                    <div v-if="produto.borda" class="alturadiv">
                                                        <span class="badge badge-success badge-pedido m-1" > <strong>Borda:</strong> {{produto.borda.nome}} </span>
                                                    </div>

                                                    <!-- Clone - Massa -->
                                                    <div v-if="produto.massa" class="alturadiv">
                                                        <span class="badge badge-success badge-pedido m-1" > <strong>Massa:</strong> {{produto.massa.nome}}</span>
                                                    </div>

                                                    <div v-if="produto.adicionais.length >0" class="alturadiv">
                                                        <span v-for="adicional, index in produto.adicionais" :key="index" class="badge badge-warning badge-pedido m-1"> +{{ adicional.nome }} </span>
                                                    </div>
                                                </div>
                                            </td>
                                            <td class="border-0 p-0 text-right">
                                                <div v-for="produto in item.produtos" :key="produto.id">
                                                    <div class="alturadiv">

                                                    </div>

                                                    <!-- Clone - Borda -->
                                                    <div v-if="produto.borda" class="alturadiv">
                                                        <span class="badge badge-success badge-pedido m-1" > +{{Intl.NumberFormat('pt-br', {style: 'currency', currency: 'BRL'}).format(produto.borda.valor*item.quantidade)}} </span>
                                                    </div>

                                                    <!-- Clone - Massa -->
                                                    <div v-if="produto.massa" class="alturadiv">
                                                        <span class="badge badge-success badge-pedido m-1" > +{{Intl.NumberFormat('pt-br', {style: 'currency', currency: 'BRL'}).format(produto.massa.valor*item.quantidade)}} </span>
                                                    </div>
                                                    <div v-if="produto.adicionais.length >0" class="alturadiv">
                                                        <span v-if="produto.valor_adicionais>0" class="badge badge-warning badge-pedido m-1"> +{{Intl.NumberFormat('pt-br', {style: 'currency', currency: 'BRL'}).format(produto.valor_adicionais*item.quantidade)}} </span> <br>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>

                                        <!-- OBS -->
                                        <tr v-if="item.obs">
                                            <td class="border-0 p-0"></td>
                                            <td class="border-0 p-0">
                                                <strong>OBS:</strong> {{item.obs}}
                                            </td>
                                            <td class="border-0 p-0 text-right">
                                            </td>
                                        </tr>



                                    </table>
                                </td>
                            </tr>
                        </tbody>

                        <tfoot>
                            <tr>
                                <th colspan="2" scope="row">Frete</th>
                                <td>{{Intl.NumberFormat('pt-br', {style: 'currency', currency: 'BRL'}).format(pedidoAtivo.frete)}}  </td>
                            </tr>
                            <tr>
                                <th colspan="2" scope="row">Desconto</th>
                                <td>-{{Intl.NumberFormat('pt-br', {style: 'currency', currency: 'BRL'}).format(pedidoAtivo.desconto)}}  </td>
                            </tr>
                            <tr>
                                <th colspan="2" scope="row">Valor Total</th>
                                <td>{{Intl.NumberFormat('pt-br', {style: 'currency', currency: 'BRL'}).format(pedidoAtivo.valor_total+pedidoAtivo.frete-pedidoAtivo.desconto)}}  </td>
                            </tr>

                        </tfoot>

                    </table>



                </div>
                <template v-if="pedidoAtivo.pagamento">
                  <p><strong>Pagamento:</strong> {{pedidoAtivo.pagamento.nome}}</p>
                  <p v-if="pedidoAtivo.pagamento.tipo==1"><strong>Troco para:</strong> {{Intl.NumberFormat('pt-br', {style: 'currency', currency: 'BRL'}).format(pedidoAtivo.pagamento.troco)}} </p>
                </template>
                  <p><strong>OBS:</strong> {{pedidoAtivo.obs}}</p>
            </div>

        </div>








        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
        </div>
      </div>
    </div>
  </div>


</div>
</template>

<script>
import api from "../service/api";
export default {
  data() {
    return {
      polling: null,
      pedidos:[],
      inquilino:{},
      pedidoAtivo: {},
      carregando:true,
    }
  },

  methods: {
    pollData () {
        this.polling = setInterval(() => {
            this.carregarPedidos()
        }, 60000)
    },

    async carregarPedidos(){
      await api
      .get('/login-user/pedidos')
      .then(response => (this.pedidos = response.data));
      this.carregando = false;
    },

    async carregarInquilino(){

        this.carregando = true;
        await api
        .get('/inquilino')
        .then(response => (this.inquilino = response.data));

        this.carregando = false
    },

    async modalPedido(pedido){

        // let obj1 = JSON.parse(JSON.stringify(pedido));
        this.pedidoAtivo = pedido
        $('#modalPedido').modal('show');
    },

  },

  beforeDestroy () {
    clearInterval(this.polling)
  },
  created () {
      this.pollData()
  },

  mounted() {
    this.carregarPedidos();
    this.carregarInquilino();
  }

}
</script>

<style scoped>

.modal {
    color: #000;
}

.pedidos a{
    text-decoration: none;
    cursor: pointer;
}

.pedidos a .card:hover{
    box-shadow: 2px 2px 6px 0px #a7a7a7;
}



.card {
    height: 100%;
    background-image: linear-gradient(to bottom, rgba(0,0,0,0),rgba(0,0,0,0), rgba(0,0,0,0.07));
    border: 1px solid rgba(0, 0, 0, 0.20);
    border-radius: 0.8rem;
}

.nav-pills .nav-link.active, .nav-pills .show > .nav-link {
    color: var(--btntxt1);
    background-color: var(--btnbg1);
}

.alturadiv {
    height: 22px;
}

</style>
